export default [
  {
    path: '/images',
    name: 'images',
    component: () => import('@/views/images/ImagesMain.vue'),
  },
  {
    path: '/images/upload',
    name: 'images-upload',
    component: () => import('@/views/images/ImagesUpload.vue'),
  },
];
